define.alias("ember-composable-helpers/helpers/intersect", "calendar/helpers/intersect");